import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * /master へのアクセスを /master/accounting-types にリダイレクト
 *
 * search パラメータ（fiscalYear 等）を保持してリダイレクトする。
 */
export const Route = createFileRoute('/_protected/master/')({
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/master/accounting-types', search });
  },
});
